<div [formGroup]="addressesForm" class="admin-dialog__section">
  <div class="form-label">
    <span class="form-label__text form-label__text--section" i18n="@@adminSystem.distributorDetails.label.address">住所</span>
  </div>
  
  <div class="admin-dialog__field-row">
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.zip">郵便番号</mat-label>
      <input matInput formControlName="zip" />
      @if (addressesForm.get('zip')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.prefecture">県</mat-label>
      <input matInput formControlName="prefecture" />
      @if (addressesForm.get('prefecture')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="admin-dialog__field-row">
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.city">市区</mat-label>
      <input matInput formControlName="city" />
      @if (addressesForm.get('city')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.town">町村</mat-label>
      <input matInput formControlName="town" />
      @if (addressesForm.get('town')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="admin-dialog__field-row">
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.line1">番地</mat-label>
      <input matInput formControlName="line1" />
      @if (addressesForm.get('line1')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.line2">建物名・部屋番号</mat-label>
      <input matInput formControlName="line2" />
    </mat-form-field>
  </div>
</div>